module.exports = __webpack_public_path__ + "4620e8f9d5a255ca142d6a4326cf6fc9.webp";